var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCirclePink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.75,
    y: 6.5,
    width: 6.5,
    height: 13,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 23.8355C7.01562 23.8355 2.16445 18.9843 2.16445 13C2.16445 7.01676 7.01562 2.16559 13 2.16559C18.9843 2.16559 23.8355 7.01676 23.8355 13C23.8354 18.9843 18.9843 23.8355 12.9999 23.8355ZM13.0043 14.898C13.2698 14.8976 13.5259 14.7998 13.724 14.6231C13.9221 14.4463 14.0484 14.203 14.0789 13.9393L14.0865 13.8136L14.0833 7.85309L14.0757 7.72634C14.0452 7.46214 13.9185 7.2184 13.7198 7.04156C13.5212 6.86472 13.2644 6.76714 12.9984 6.76741C12.7325 6.76768 12.4759 6.86577 12.2776 7.04301C12.0793 7.22025 11.9531 7.46424 11.9231 7.72851L11.9166 7.85526L11.9199 13.8147L11.9275 13.9414C11.9588 14.2049 12.0857 14.4478 12.2842 14.6239C12.4827 14.8 12.7389 14.8972 13.0043 14.8969L13.0043 14.898ZM12.9999 18.9594C13.3595 18.9594 13.7044 18.8166 13.9586 18.5623C14.2129 18.3081 14.3557 17.9632 14.3557 17.6036C14.3557 17.2441 14.2129 16.8992 13.9586 16.6449C13.7044 16.3907 13.3595 16.2478 12.9999 16.2478C12.6404 16.2478 12.2955 16.3907 12.0413 16.6449C11.787 16.8992 11.6442 17.2441 11.6442 17.6036C11.6442 17.9632 11.787 18.3081 12.0413 18.5623C12.2955 18.8166 12.6404 18.9594 12.9999 18.9594Z",
    fill: "#F2C4D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCirclePink);
export default __webpack_public_path__ + "static/media/info-circle-pink.5289a532826923068d46404ca61d0b4e.svg";
export { ForwardRef as ReactComponent };